import win from '../imports/window';

export const hasWebGL2Support = () =>
  Boolean(win?.document.createElement('canvas').getContext('webgl2'));
